// Accounting Purchases Vuex

import state from './saleReturnStates.js'
import * as getters from './saleReturnGetters.js'
import * as mutations from './saleReturnMutations.js'
import * as actions from './saleReturnActions.js'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
